import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { AuthService } from './auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private _router: Router;
    private get router() {
        if (!this._router) {
            this._router = this.injector.get(Router);
        }

        return this._router;
    }

    constructor(public auth: AuthService, private injector: Injector) { }

    public async interceptAsync(request: HttpRequest<any>, next: HttpHandler, allowAuthRetry: boolean = true): Promise<HttpEvent<any>> {
        let token = await this.auth.getIdToken();
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });

        try {
            return await next.handle(request).toPromise();
        } catch (error) {
            if (error.status === 401 && allowAuthRetry) {
                let user = await this.auth.getCurrentUser();
                if (!user) {
                    this.router.navigateByUrl('/user/login');
                    return undefined;
                } else {
                    let authenticated = await this.auth.authenticateWithModal();
                    if (authenticated) {
                        // Retry the method, without retrying
                        return this.interceptAsync(request, next, false);
                    } else {
                        throw error;
                    }
                }
            } else {
                throw error;
            }
        }
    }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return fromPromise(this.interceptAsync(request, next));
    }
}


// WEBPACK FOOTER //
// ./src/app/services/tokenInterceptor.ts